import { motion, useReducedMotion } from 'motion/react';

function FloatingPaths({
  position,
  className = 'text-zeb-primary'
}: {
  position: number;
  className?: string;
}) {
  const prefersReduced = useReducedMotion();

  const paths = Array.from({ length: 36 }, (_, i) => ({
    id: i,
    d: `M-${380 - i * 5 * position} -${189 + i * 6}C-${
      380 - i * 5 * position
    } -${189 + i * 6} -${312 - i * 5 * position} ${216 - i * 6} ${
      152 - i * 5 * position
    } ${343 - i * 6}C${616 - i * 5 * position} ${470 - i * 6} ${
      684 - i * 5 * position
    } ${875 - i * 6} ${684 - i * 5 * position} ${875 - i * 6}`,
    width: 0.5 + i * 0.03
  }));

  return (
    <svg
      className={`absolute inset-0 h-full w-full ${className}`}
      viewBox="0 0 696 316"
      fill="none"
      preserveAspectRatio="xMaxYMid slice">
      {paths.map((path) => (
        <motion.path
          key={path.id}
          d={path.d}
          stroke="currentColor"
          strokeWidth={path.width}
          // Dezent: Snippet-Größenordnung global gedämpft (~0.6),
          // damit die Headline-Lesbarkeit erhalten bleibt.
          strokeOpacity={(0.06 + path.id * 0.018) * 0.6}
          initial={{ pathLength: 0.3, opacity: 0.6 }}
          animate={
            prefersReduced
              ? undefined
              : {
                  pathLength: 1,
                  opacity: [0.3, 0.6, 0.3],
                  pathOffset: [0, 1, 0]
                }
          }
          transition={
            prefersReduced
              ? undefined
              : {
                  duration: 20 + (path.id % 10),
                  repeat: Number.POSITIVE_INFINITY,
                  ease: 'linear'
                }
          }
        />
      ))}
    </svg>
  );
}

export function BackgroundPaths({ className }: { className?: string }) {
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
      <FloatingPaths position={1} className={className} />
      <FloatingPaths position={-1} className={className} />
    </div>
  );
}
